import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    agentStateDuration: 0,
    wrapUpTime: 0,
    autoUpdateAgentState: {
        countDown: null,
        altered: false
    },
    reUpdateTimer: false,
    timeAfterPauseReason: 0,
    holdTime: 0,
    muteTime: 0,
    pauseReason: '',
    remainGraceTime:0
};

export const timerSlice = createSlice({
    name: 'timer',
    initialState,
    reducers: {
        setAgentStateDuration: (state, action) => {
            state.agentStateDuration = action.payload
        },
        setWrapUpTime: (state, action) => {
            state.wrapUpTime = action.payload
        },
        setAutoUpdateAgentState: (state, action) => {
            state.autoUpdateAgentState = action.payload
        },
        setReUpdateTimer: (state, action) => {
            state.reUpdateTimer = action.payload
        },
        setTimeAfterPauseReason: (state, action) => {
            state.timeAfterPauseReason = action.payload
        },
        setPauseReason: (state, action) => {
            state.pauseReason = action.payload;
        },
        setHoldTime: (state, action) => {
            state.holdTime = action.payload
        },
        setMuteTime: (state, action) => {
            state.muteTime = action.payload
        },
        setRemainGraceTime: (state, action) => {
            state.remainGraceTime = action.payload
        },
    }
})

export const {setRemainGraceTime, setPauseReason, setAgentStateDuration, setReUpdateTimer, setWrapUpTime, setAutoUpdateAgentState, setTimeAfterPauseReason, setMuteTime,
    setHoldTime,
} = timerSlice.actions;
export default timerSlice.reducer;